import { useState } from 'react';
import { ReactComponent as Chevron } from '../../../assets/icons/trvto_downArrow.svg';
import { stayAmounts } from '../campReviewFun/stayAmounts';
import StayUnitPrices from '../../campDetails/campBookingTab/StayUnitPrices';

const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

const PAYMENT_TYPES = [
    { value: 'UPI', label: 'UPI' },
    { value: 'OTHERS', label: 'Others' }
];

/*
 * Right column — same layout and classes as the trip / activity review
 * (price box with "Change Details", payment type, terms, Confirm).
 */
export default function StayPricePanel({ stay, paymentType, onPaymentTypeChange, onConfirm, onChangeDetails, disabled }) {
    const { pricing = {} } = stay;
    const { dueNow, payNow, payLater } = stayAmounts(stay, paymentType);
    // shown like the other pages: fee added, then taken off again for UPI
    const { fee } = stayAmounts(stay, 'OTHERS');
    const reserving = payLater > 0;
    // rooms per unit come from the booked items (same order as the price lines)
    const unitLines = (pricing.lines || []).map((line, i) => ({ ...line, rooms: line.rooms || stay.items?.[i]?.rooms }));

    // mobile: folds down to a bar with the total + Confirm
    const [expanded, setExpanded] = useState(true);
    const toggle = () => setExpanded((v) => !v);

    return (
        <div className={`tripBookingTab ${expanded ? 'expanded' : 'collapsed'}`}>
            <div className='tripBookingPriceDiv'>
                <div className='toggleOverlay' onClick={toggle} />
                <div className='internalFlex'>
                    <h2 className='reviewBoSumH1'>Price Summary</h2>
                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>{inr(payNow)}</p>
                    </div>
                </div>
                <button type='button' onClick={toggle} className='collapseArrow' aria-label='Show price details'>
                    <Chevron width={24} height={24} />
                </button>
                <button className='reviewButton reviewBoSumSmallConfirm' type='button' onClick={onConfirm} disabled={disabled}>
                    Confirm
                </button>
            </div>

            <div className='tripBookingSubTab'>
                <div className='tripBookDataInput'>
                    {reserving ? (
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>Reserve amount</p>
                            <p className='tripBookPrice'>{inr(dueNow)}</p>
                        </div>
                    ) : (
                        <>
                            {pricing.lines?.length > 1 ? (
                                // several units: one summary row with a dropdown (same as the booking tab)
                                <StayUnitPrices lines={unitLines} nights={stay.nights} format={inr} />
                            ) : (
                                <div className='tripPriceCal'>
                                    <p className='tripBookPrice'>
                                        {inr(pricing.listPrice || pricing.nightly)} × {pricing.quantityLabel}
                                    </p>
                                    <p className='tripBookPrice'>{inr(pricing.listBase || pricing.subtotal)}</p>
                                </div>
                            )}
                            {pricing.savings > 0 && (
                                <div className='tripBookOfferDiv'>
                                    <p className='tripBookOfferText'>Discount</p>
                                    <p className='tripBookOfferText'>- {inr(pricing.savings)}</p>
                                </div>
                            )}
                            {pricing.tax > 0 && (
                                <div className='tripBookOfferDiv'>
                                    <p className='tripBookOfferText'>Tax</p>
                                    <p className='tripBookOfferText'>+ {inr(pricing.tax)}</p>
                                </div>
                            )}
                        </>
                    )}
                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Convenience Fee</p>
                        <p className='tripBookOfferText'>+ {inr(fee)}</p>
                    </div>
                    {paymentType === 'UPI' && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>UPI Offers</p>
                            <p className='tripBookOfferText'>- {inr(fee)}</p>
                        </div>
                    )}
                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>Total:</p>
                        <p className='tripBookTotalText'>{inr(payNow)}</p>
                    </div>
                    <span />
                    <button type='button' className='reviewBoSumChangeBtn grayBtn' onClick={onChangeDetails}>
                        Change Details
                    </button>
                </div>

                <div>
                    {reserving && (
                        <div className='leftAmountDiv'>
                            Remaining amount to be paid at the stay {inr(payLater)} (including tax)
                        </div>
                    )}
                    <p className='tripBookPriceText'>Choose Payment Type</p>
                    <div className='paymentTypeWrapper'>
                        {PAYMENT_TYPES.map((t) => (
                            <div key={t.value} className='paymentTypeDiv'>
                                <input
                                    type='radio'
                                    name='stayPaymentType'
                                    id={`stayPay${t.value}`}
                                    value={t.value}
                                    checked={paymentType === t.value}
                                    onChange={() => onPaymentTypeChange(t.value)}
                                />
                                <label htmlFor={`stayPay${t.value}`} className='tripBookPaymentType'>
                                    {t.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    {paymentType === 'UPI' && <span className='reviewBoSumCondition'>*UPI Offers - Save up to ₹1000</span>}
                </div>

                <div className='tripBookBtnDiv'>
                    <p className='reviewBoSumCondition'>
                        By clicking on the Confirm button, You accept our{' '}
                        <a href='/terms' target='_blank' rel='noopener noreferrer'>
                            Terms & Conditions
                        </a>
                        ,{' '}
                        <a href='/cancellation-policy' target='_blank' rel='noopener noreferrer'>
                            Cancellation Policy
                        </a>
                        , and{' '}
                        <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>
                            Privacy Policy
                        </a>
                    </p>
                    <button className='reviewButton reviewBoSumConfirm' type='button' onClick={onConfirm} disabled={disabled}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}
